var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSymbolsSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "CurrentIconColor2",
    d: "M18.5 5.55556V16.2222C18.5 16.7111 18.3258 17.1298 17.9773 17.4782C17.6289 17.8267 17.2105 18.0006 16.7222 18H4.27778C3.78889 18 3.37022 17.8258 3.02178 17.4773C2.67333 17.1289 2.49941 16.7105 2.5 16.2222V3.77778C2.5 3.28889 2.67422 2.87022 3.02267 2.52178C3.37111 2.17333 3.78948 1.99941 4.27778 2H14.9444L18.5 5.55556ZM10.5 15.3333C11.2407 15.3333 11.8704 15.0741 12.3889 14.5556C12.9074 14.037 13.1667 13.4074 13.1667 12.6667C13.1667 11.9259 12.9074 11.2963 12.3889 10.7778C11.8704 10.2593 11.2407 10 10.5 10C9.75926 10 9.12963 10.2593 8.61111 10.7778C8.09259 11.2963 7.83333 11.9259 7.83333 12.6667C7.83333 13.4074 8.09259 14.037 8.61111 14.5556C9.12963 15.0741 9.75926 15.3333 10.5 15.3333ZM5.16667 8.22222H13.1667V4.66667H5.16667V8.22222Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolsSave);
export default __webpack_public_path__ + "static/media/symbols_save.cdfe93a837c153d37944d542392ed603.svg";
export { ForwardRef as ReactComponent };